import React from "react";
import Styles from "./PlanYourTrip.module.css";

import TextField from "@material-ui/core/TextField";
import { useField } from "formik";

function Budget({ name, label }) {
	const [field, meta] = useField(name);

	const configDateTimePicker = {
		...field,
		name,
		label,
		variant: "outlined",
		InputLabelProps: {
			shrink: true,
		},
		error: meta && meta.touched && meta.error,
		helperText:
			meta && meta.touched && meta.error ? meta.error : "",
	};
	return (
		<div className={Styles.budget}>
			<h4> $</h4>

			<TextField
				{...configDateTimePicker}
				type='number'
				inputProps={{ min: "30" }}
				id={name}
				variant='outlined'
				label={label}
			/>
		</div>
	);
}

export default Budget;
